(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-with-flyout"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    // Add mobile menu toggle functionality
    const mobileToggle = document.createElement('button');
    mobileToggle.classList.add('shopify-section-mega-nav__mobile-toggle');
    mobileToggle.innerHTML = '☰';

    const megaNav = document.querySelector('.shopify-section-mega-nav__container');
    const menuList = document.querySelector('.shopify-section-mega-nav__list');

    if (window.innerWidth <= 768) {
      megaNav.insertBefore(mobileToggle, menuList);
      menuList.style.display = 'none';
    }

    mobileToggle.addEventListener('click', function() {
      menuList.style.display = menuList.style.display === 'none' ? 'flex' : 'none';
    });

    // Handle window resize
    window.addEventListener('resize', function() {
      if (window.innerWidth <= 768) {
        if (!megaNav.contains(mobileToggle)) {
          megaNav.insertBefore(mobileToggle, menuList);
        }
        menuList.style.display = 'none';
      } else {
        if (megaNav.contains(mobileToggle)) {
          mobileToggle.remove();
        }
        menuList.style.display = 'flex';
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-fit-div"] && !Shopify.designMode) return;
  try {
    
  // Immediately mark as loaded to prevent layout shifts
  if (document.querySelector('[data-hero-fit]')) {
    document.querySelector('[data-hero-fit]').classList.add('js-loaded');
  }

  document.addEventListener('DOMContentLoaded', () => {
    const HeroFit = {
      init() {
        this.isMobile = window.innerWidth <= 768;
        
        // Always initialize mute button regardless of device
        this.initMuteButton();
        
        // Defer GSAP animations to not block initial render
        if (!this.isMobile && typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
          // Use setTimeout to defer animation setup after critical rendering
          setTimeout(() => {
            gsap.registerPlugin(ScrollTrigger);
            this.initGSAPAnimations();
          }, 100);
        }
      },

      initMuteButton() {
        const video = document.querySelector('[data-hero-video]');
        const muteBtn = document.querySelector('[data-mute-button]');
        const playBtn = document.querySelector('[data-play-button]');
        
        if (video && muteBtn) {
          muteBtn.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            
            if (video.muted) {
              video.muted = false;
              muteBtn.querySelector('.icon-muted').style.display = 'none';
              muteBtn.querySelector('.icon-unmuted').style.display = 'block';
            } else {
              video.muted = true;
              muteBtn.querySelector('.icon-muted').style.display = 'block';
              muteBtn.querySelector('.icon-unmuted').style.display = 'none';
            }
          });
        }

        // Handle play button on mobile
        if (video && playBtn) {
          playBtn.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            
            const videoSrc = video.dataset.src;
            if (!videoSrc) return;

            // Load and play the video
            if (!video.src) {
              const posterImg = document.querySelector('.video-poster');
              
              playBtn.querySelector('.icon-play').style.display = 'none';
              playBtn.querySelector('.icon-loading').style.display = 'block';
              
              // Make sure video element is visible
              video.style.display = 'block';
              video.style.visibility = 'visible';
              
              // Set video source and load
              video.src = videoSrc;
              video.load();
              
              video.addEventListener('canplaythrough', () => {
                // Video is ready to play through without buffering
                const playPromise = video.play();
                if (playPromise !== undefined) {
                  playPromise.then(() => {
                    // Fade in video, fade out poster
                    video.style.opacity = '1';
                    if (posterImg) {
                      posterImg.style.opacity = '0';
                      // Remove poster from DOM after transition
                      setTimeout(() => {
                        posterImg.remove();
                      }, 300);
                    }
                    
                    // Hide play button, show mute button
                    playBtn.style.display = 'none';
                    muteBtn.style.display = 'flex';
                  }).catch(error => {
                    console.log('Video autoplay failed:', error);
                    // Reset play button
                    playBtn.querySelector('.icon-play').style.display = 'block';
                    playBtn.querySelector('.icon-loading').style.display = 'none';
                  });
                }
              }, { once: true });

              video.addEventListener('error', () => {
                // Hide video on error, keep poster visible
                video.style.display = 'none';
                console.log('Video failed to load');
                // Reset play button
                playBtn.querySelector('.icon-play').style.display = 'block';
                playBtn.querySelector('.icon-loading').style.display = 'none';
              }, { once: true });
              
            } else {
              // Video already loaded, just play/pause
              if (video.paused) {
                video.play();
                playBtn.querySelector('.icon-play').style.display = 'none';
                playBtn.querySelector('.icon-pause').style.display = 'block';
              } else {
                video.pause();
                playBtn.querySelector('.icon-play').style.display = 'block';
                playBtn.querySelector('.icon-pause').style.display = 'none';
              }
            }
          });
        }
      },

      initLazyVideo() {
        const videoWrapper = document.querySelector('[data-video-wrapper]');
        const video = document.querySelector('[data-hero-video]');
        const videoSrc = video?.dataset.src;
        
        if (!videoWrapper || !video || !videoSrc) return;

        // Check if device supports video and has good connection
        const shouldLoadVideo = this.shouldLoadVideo();
        
        if (!shouldLoadVideo) {
          // On mobile, don't hide video - let play button handle it
          // On desktop with poor connection, hide video completely
          if (window.innerWidth >= 768) {
            video.style.display = 'none';
          }
          return;
        }

        // Use Intersection Observer for lazy loading (desktop only)
        if ('IntersectionObserver' in window) {
          const videoObserver = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
              if (entry.isIntersecting) {
                this.loadVideo(video, videoSrc);
                videoObserver.unobserve(entry.target);
              }
            });
          }, {
            rootMargin: '50px' // Start loading 50px before it comes into view
          });

          videoObserver.observe(videoWrapper);
        } else {
          // Fallback for older browsers - load immediately
          this.loadVideo(video, videoSrc);
        }
      },

      shouldLoadVideo() {
        // Don't load video on mobile devices to save bandwidth
        if (window.innerWidth < 768) return false;
        
        // Check for reduced motion preference
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return false;
        
        // Check connection speed (if available)
        if ('connection' in navigator) {
          const connection = navigator.connection;
          // Don't load video on slow connections
          if (connection.effectiveType === 'slow-2g' || 
              connection.effectiveType === '2g' || 
              connection.effectiveType === '3g') {
            return false;
          }
          // Check if data saver is enabled
          if (connection.saveData) {
            return false;
          }
        }
        
        return true;
      },

      loadVideo(video, src) {
        const posterImg = document.querySelector('.video-poster');
        
        video.src = src;
        video.load();
        
        video.addEventListener('canplaythrough', () => {
          // Video is ready to play through without buffering
          const playPromise = video.play();
          if (playPromise !== undefined) {
            playPromise.then(() => {
              // Fade in video, fade out poster
              video.style.opacity = '1';
              if (posterImg) {
                posterImg.style.opacity = '0';
                // Remove poster from DOM after transition
                setTimeout(() => {
                  posterImg.remove();
                }, 300);
              }
            }).catch(error => {
              console.log('Video autoplay failed:', error);
              // Keep poster visible if video fails
            });
          }
        });

        video.addEventListener('error', () => {
          // Hide video on error, keep poster visible
          video.style.display = 'none';
          console.log('Video failed to load');
        });
      },

      initGSAPAnimations() {
        const overlay = document.querySelector('[data-hero-overlay]');
        const columns = document.querySelectorAll('[data-hero-column]');
        
        if (!overlay || columns.length === 0) return;

        // Delay animation initialization to improve LCP
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            // Create timeline for the entire animation sequence
            const tl = gsap.timeline({
              scrollTrigger: {
                trigger: '[data-hero-fit]',
                start: 'top top',
                end: 'bottom top',
                scrub: 1,
                pin: true,
                anticipatePin: 1,
                invalidateOnRefresh: true
              }
            });

            // Stage 1: Overlay centers (clip-path animation) - slower and gentler
            // Start from visible state for better LCP
            tl.fromTo(overlay, {
              clipPath: 'inset(0 0 0 0)'
            }, {
              clipPath: 'inset(0 33.333% 0 33.333%)',
              duration: 0.7,
              ease: 'power1.inOut'
            })
            // Stage 2: Columns slide up
            .to(columns, {
              y: 0,
              duration: 0.5,
              ease: 'power2.out',
              stagger: 0.1
            }, 0.6);
          });
        });

        // Additional ScrollTrigger for refresh on resize
        ScrollTrigger.addEventListener('refresh', () => {
          this.isMobile = window.innerWidth <= 768;
          if (this.isMobile) {
            ScrollTrigger.getAll().forEach(trigger => trigger.kill());
          }
        });
      }
    };

    if (document.querySelector('[data-hero-fit]')) {
      HeroFit.init();
      HeroFit.initLazyVideo();
    }

    // Handle window resize
    window.addEventListener('resize', () => {
      if (typeof ScrollTrigger !== 'undefined') {
        ScrollTrigger.refresh();
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
